module.exports = __webpack_public_path__ + "static/media/language.3b659291.jpg";